import React, { Component } from 'react';
import { connect } from 'react-redux';
import { orderBy } from 'lodash';
import { TableRow, TableCell, Table, TableHead, TableFooter } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Point from '@material-ui/icons/ArrowDropDown';
import {
  navigateTo,
  saveHistory,
  getPaitentsWithNoClinic,
  getPatients,
  getPatientsByClinicId,
  getAllPatients,
  setSelectedPatient,
  getClinicData,
} from '../../redux/actions';
import { patientListBaseStyles } from '../../theme/style';
import { Items, Storage } from '../../utils/StorageHelper';
import { isNonPaitentsClinic, isPaitents, statusTypes } from '../../utils/CFuncs';
import EntityTable from '../common/EntityTable';
import { patientTableFields, urls } from '../../utils/Objects';
import { Loading } from '../common';

class PatientList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      patients:this.props.patients || [],
    };
  }


  async componentDidMount() {
    const newList = await this.getAllDatas();
    this.setState({ patients: newList });
    const clinicId = Storage.get(Items.clinicId);
    if (clinicId) {
      if (!this.props.selectedClinic) this.props.getClinicData(clinicId);
      this.props.getPatientsByClinicId(clinicId );
    } else {
      this.props.getPatients( );
    }
  }

  async componentDidUpdate(prevProps) {
    console.log('componentDidUpdate');
    console.log(this.props.patients);
    if (JSON.stringify(this.props.patients) !== JSON.stringify(prevProps.patients)) {
      const newUserList = await this.getAllDatas();
      this.setState({ patients: newUserList });
    }
  }

  getAllDatas = () => {
    const newList = this.props.patients?.map((patient) => {
      const percent = patient.complianceBuckets[this.props.timeframe].percent;
      const { lastName, firstName, email } = patient;

      const statusName = statusTypes[patient.status];

      return {
        id: patient.id,
        image: {
          picture: patient.picture,
          id: patient.id,
        },
        lastName,
        firstName,
        email,
        goal: {
          value: patient.complianceHours ?? 'unset',
          pathname: urls.patientGoal,
          onClick: () => this.props.setSelectedPatient(patient),
        },
        compliance: Math.round(percent, 2),
        status: {
          statusName,
          pathname: urls.patientStatus,
          state: { user: patient, prevPage: urls.patients },
        },
        clinics: patient.clinics.map((clinic) => clinic.name),
        details: {
          pathname: urls.patientDetails,
          state: { patient },
        },
      };
    });
    console.log({ newList });
    return newList;
  };
  render() {
    return (
      <div>
        {isPaitents() && <h1> Patients</h1>}
        {isNonPaitentsClinic() && <h1>Non Clinic Patients</h1>}
        {this.props.isLoading && <Loading />}
        <EntityTable entities={this.state.patients} tableFields={patientTableFields} />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    selectedClinic: state.clinic.selectedClinic,
    patients: state.clinic.patientsList,
    timeframe: state.filter.timeframe,
    isLoading:state.message.isLoading

  };
};
const mapDispatchToProps = {
  saveHistory,
  navigateTo,
  getPaitentsWithNoClinic,
  getPatients,
  getAllPatients,
  getPatientsByClinicId,
  setSelectedPatient,
  getClinicData,
};

export default connect(mapStateToProps, mapDispatchToProps)(PatientList);
